<template>
    <div class="equipe" >
        
        <div v-if="equipe ">
        <div class="equipeForme">
         <equipe-item-forme
                    :equipe="equipe"
                    :type="type"
                    :changeFlagJoueur="changeFlagJoueur"
                    :showError="showError"
                    :indexPartie="indexPartie"
                    :theme="null"
                    :joueurs="joueurs"
                    @errorJoueur = "errorJoueur"
                    @editJoueur = "editJoueur"
                />
        </div>
        <div v-if="equipe[type] && tournoi.options.championnat.type=='gg'"> 
               
                <s-button label="Gagne" @onclick="win" theme="is-success"
                    :role="role"
                    :disabled="!(partie.state=='INPROGRESS') || disabledScore || (role=='player')"
                   icon="question" v-if="!jeuTermine() && typeof(equipe[type].J1.qualifie)=='undefined'"
                />
                <div v-if="jeuTermine() && typeof(equipe[type].J1.qualifie)=='undefined'">
                   <div v-if="quiAgagne(type, vsType)" >
                      <div v-if="indexPartie==0" class="YOUWIN"> Gagne</div>
                      <div v-if="indexPartie==1" class="BARRAGE"> Barrage</div>
                      <div v-if="indexPartie==2" class="YOUWIN"> Qualifié</div>
                      <div v-if="indexPartie>2" class="YOUWIN"> Gagne</div>
                   </div>
                   <div v-if="quiAgagne(vsType, type)" >
                       <div v-if="indexPartie==0" class="YOULOSE"> Perdu</div>
                       <div v-if="indexPartie==1" class="BARRAGE"> Barrage</div>
                      <div v-if="indexPartie==2" class="YOULOSE"> Non qualifié</div>
                      <div v-if="indexPartie>2" class="YOULOSE"> Perdu</div> 
                   </div>
                </div>
                <div  v-if="typeof(equipe[type].J1.qualifie)!='undefined' && equipe.score.joueurs!=null">
                   <div v-if="!equipe[type].J1.qualifie" class="YOULOSE">
                       Non qualifié
                   </div>
                   <div v-if="equipe[type].J1.qualifie" class="YOUWIN">
                       Qualifié
                   </div>
                </div>
             <span v-show="!displayNormal">&nbsp;<br/><br/></span>
        </div>
         <div v-if="equipe[type] && tournoi.options.championnat.type=='classique'"> 
             <p class="control has-icons-left " v-show="equipe.state=='FINISH'">
                <div :class="type=='joueurs' ? 'scoreJ' : 'scoreC'" v-if="equipe.state=='FINISH'">
                    <span v-if="!tournoiPouleGG && (indexPartie<3 || equipe[vsType].J1.numero!=null)">
                        {{equipe.score[type]}} 
                        <span v-if="!tournoiPouleGG && equipe[vsType].J1.numero==null">
                            / {{equipe.score[vsType]}}
                        </span>
                    </span>
                    <span v-if="tournoiPouleGG">
                        {{equipe.score[type]}} 
                    </span>
                </div>
            </p>
            <p class="control" v-show="equipe.state!='FINISH' && displayNormal">
                <s-button 
                    :label="((isNaN(equipe.score[type]) || equipe.score[type]==null) ? '' : equipe.score[type])+' ? '" 
                    theme="is-normal" 
                    @onclick="openModalScore"
                    :disabled="partie.state=='WAITING' || (role!='owner' && role!='admin')"
                    :id="equipe.id+'_'+type"
                />
            </p>
         </div>
        </div>
    </div>
</template>
<style scoped>
    .equipeForme {
        height: 90px;
    }
    .scoreJ {
         background-color: rgb(7, 60, 95);
        padding: 5px;
        border-radius: 10px;
        color: white;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 0px;
        font-size: 20px;
        font-weight:bolder;
    }
     .scoreC {
        background-color: rgb(138, 14, 14);
        padding: 5px;
        border-radius: 10px;
        color: white;
        margin-left: 10px;
        margin-right: 10px;
         margin-top: 0px;
        font-size: 20px;
        font-weight:bolder;
    }
    .BARRAGE {
        background-color: rgb(218, 198, 22);
        margin: 5px;
        border-radius: 10px;
    }
    .YOUWIN {
        background-color: greenyellow;
        margin: 5px;
        border-radius: 10px;
    }
    .YOULOSE {
        background-color: rgb(255, 78, 47);
        margin: 5px;
        color: white;
        border-radius: 10px;
    }
    .anomnymecontre {
        font-style: italic;
        color: rgb(247, 181, 181);
    }
    .anomnymejoueurs {
        font-style: italic;
        color: rgb(212, 220, 245);
    }
    .equipe {
         
    }
    .joueurItem {
        
        height: 33px;
        padding-top: 0px;
        font-size: 15px;
        width: 140px;
        color: white;
    }
     .joueurItemVS {
        height: 33px;
        padding-top: 0px;
        font-size: 15px;
        width: 140px;
        color: white;
    }
    .pseudo {
        margin-left: 60px;
        width: 70px;
        text-overflow: ellipsis;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
    }
    .pseudoChange {
        margin-left: 65px;
        width: 60px;
        text-overflow: ellipsis;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
    }
    
</style>
<script>
import equipeItemForme from  "@/views/tournoi/inProgress/equipe/equipeItemForme.vue"
export default {
    props: {
        mode: {
            type: String,
            detault: ""
        },
        equipe: {
            type: [Object,Array]
        },
        tournoi: {
            type: [Object,Array]
        }, 
        options: {
            type: [Object,Array]
        }, 
        joueurs: Array, 
        type: String, 
        changeFlagJoueur: Boolean,
        disabledScore: {
            type: Boolean,
            default: false
        },
        qualified: {
            type: Boolean,
            default: false
        },
        showError: {
            type: Boolean,
            default: false
        },
        indexPartie: {
            type: Number
        },
        role: {
            type: String,
            default: "owner"
        },
        partie: {
            type: [Object,Array]
        }
        },
        
    data() {
            return {
                openJoueurModify : false,
                joueurSelected: null,
                error: false
            }
        },
    components: {
        equipeItemForme
    },
    computed: {
        tournoiPouleGG: {
            get() {
                var GG = true;
                if (typeof(this.tournoi.options.championnat)!="undefined")
                    if (this.tournoi.options.championnat.type == 'classique')
                        GG = false;
                return GG;
            }
        },
        pointMax: {
            get() {
                if (this.partie!=null)
                    if (typeof(this.partie.maxPoint)=="undefined")
                        return 13;
                    else
                        return this.partie.maxPoint
                else
                    return 13;
            },
            set(val) {
                this.partie.maxPoint = parseInt(val);
            }
        },
        forme: {
            get() {
                return (this.mode == "FORME")
            }
        },
        vsType: {
            get() {
                return this.type=='joueurs' ? 'contre' : 'joueurs'
            }
        },
        displayNormal: {
            get() {
              
                if (this.options) {
                    if (this.options.allEquipePlay)
                        return true;
                    else if (this.options.addPartie) {
                        
                        return (this.equipe.joueurs.J2 != null)
                    }
                    else    
                        return true;
                    }
               else return true;
            }
        }
        
    },
    methods: {
         openModalScore() {
            this.$emit("openModalScore",this.equipe, this.type);
        },
        jeuTermine() {
            var bool = this.equipe.score["joueurs"] == this.pointMax ||  this.equipe.score["contre"] == this.pointMax;
            return bool && this.equipe.state == "FINISH"
        },
        quiAgagne(type, typeVS) {
            return  this.equipe.score[type] > this.equipe.score[typeVS];
        },
        qualifie(numero) {
            if (this.qualified)
                return 1;
            else if (this.indexPartie==2) {
                if (typeof(this.tournoi.qualified)!="undefined") {
                    var indexLast;
                    var qualifie = -1;
                    for (var key in this.tournoi.qualified)  {
                        indexLast = key;
                        if (typeof(this.tournoi.qualified[indexLast])!="undefined") {
                            if (this.tournoi.qualified[indexLast].indexOf(numero)!=-1) 
                                qualifie = 1;
                            else if (this.tournoi.disqualified[indexLast].indexOf(numero)!=-1)
                                qualifie = 0;
                        }
                    }
                    return qualifie;
                }
                else
                    return -1;
            }
            else   
                return -1;
        },
        typeError(type) {
            switch (type) {
                case 1:
                    return "exchange-alt"
                    break;
                case 2:
                    return "user-friends"
                    break;
                case 3:
                    return "users-slash"
                    break;
                case 4:
                    return "ban"
                    break;
                default:
                    break;
            }
        },
        changeScoreOut() {
            var typeVS = this.type == "contre" ? "joueurs" : "contre";
            
            if (this.equipe.score[this.type]!=null) {
                if (this.equipe.score[this.type]!=13) {
                    if (this.equipe.score[typeVS] == '' || this.equipe.score[typeVS] == null) {
                        this.equipe.score[typeVS] = 13;
                    } 
                }
                if (this.equipe.score[this.type] == '')
                    this.equipe.score[this.type] = 0;
                if (this.equipe.score[this.type] < 0)
                    this.equipe.score[this.type] = 0;
                
                this.error = (this.equipe.score[this.type] != 13 && this.equipe.score[typeVS] != 13);
            }
        },
        errorJoueur(joueur) {
            if (this.showError) {
                if (joueur) {
                    if (typeof(joueur.errorDetail[this.indexPartie]) != "undefined") {
                        return joueur.errorDetail[this.indexPartie];
                    }
                    else
                        return null;
                }
                else
                    return null;
            }
            else
                return false
            
        },
        
        editJoueur(joueur, vs, idJoueur) {
          
            this.joueurSelected = joueur;
            if (this.changeFlagJoueur) {
                if (joueur == null) {
                    this.joueurSelected = {
                        numero: null,
                        vs: vs,
                        idJoueur: idJoueur
                    }
                }
               
                this.$emit("changeEffect", this.joueurSelected, this.equipe)
            }
            else {
                
                this.openJoueurModify = true;
                this.$emit("selectJoueur", this.joueurSelected, this.equipe)
            }
        },
        win() {
            this.equipe.score[this.type] = 13;
            this.equipe.score[this.vsType] = 7;
           
            this.$emit("saveScore", this.equipe);
        },
        changeScore() {
            this.$emit("change", this.equipe);
        }
        
    }
}
</script>